import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Landing, DesktopFallback, MarkdownPage } from './screens';
import { ScrollToTop } from './components';
import { HTML_LANG, Language } from './constants';
import { ROUTES } from './Routes';

function App() {
  const [lang, setLang] = useState<Language>('EN');

  useEffect(() => {
    document.documentElement.lang = HTML_LANG[lang];
  }, [lang]);

  if (!isMobile) {
    return <DesktopFallback lang={lang} setLang={setLang} />;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path={ROUTES.HOME} element={<Landing lang={lang} setLang={setLang} />} />
        <Route path={ROUTES.ABOUT} element={<MarkdownPage file="about" lang={lang} />} />
        <Route path={ROUTES.TERMS} element={<MarkdownPage file="terms" lang={lang} />} />
        <Route path={ROUTES.CREDITS} element={<MarkdownPage file="credits" lang={lang} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
